const prototypes = {
}
const components = {
}

export const install = function (Vue, options) {
  if (install.installed) {
    return
  }
  install.installed = true

  if (options.Layout) {
    window.sharedLayout = options.Layout
  }

  Object.values(components).map(component => {
    Vue.use(component)
  })

  Object.keys(prototypes).forEach((key) => {
    Vue.prototype['$' + key] = prototypes[key];
  });
  console.log(12345)
  var modules = require('../src/modules').default
  console.log(modules)
  options.WebHost && options.WebHost.registerModule(modules)
}


export default {
  version: '1.0.0',
  install,
  ...components
}
